import { createAction } from '@reduxjs/toolkit';
import { CaptionsSpokenLanguage } from 'features/application/types';
import { CaptionsSpeechChunk } from 'features/transcripts/slices/captions/types';
import { SignalingEventPayload } from 'services/signaling';

export const speechCaptioned = createAction<CaptionsSpeechChunk>('captions/speechCaptioned');

export const startTranscriptionRequested = createAction('room/transcription/startRequested');
export const stopTranscriptionRequested = createAction('room/transcription/stopRequested');

export const signalingTranscriptionStarted = createAction('signaling/transcription/started');
export const signalingTranscriptionStopped = createAction('signaling/transcription/stopped');

export const signalingTranscriptionSpokenLanguageChanged = createAction<
  SignalingEventPayload<{ code: CaptionsSpokenLanguage; applyToAll?: boolean }>
>('signaling/transcription/spokenLanguageChanged');
